import React from 'react';

export default function ProductFormHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Add Product</h2>
        </div>
      </div>
  );
}
